module.exports = __webpack_public_path__ + "static/media/229-papua-new-guinea.0e673e20.svg";